import state from "./state";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";
import search from "./search";
import mainlist from "./mainlist";
export default {
  modules: {
    search: search,
    mainlist: mainlist
  },
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};